import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentProject: {},
    tasks: [],
    currentTask: {},
    notes: [],
    posts: [],
  },

  getters: {
    tasksByStatus: (state) => (status) => {
      return state.tasks.filter(task => task.status === status);
    },
    currentProjectId(state) {
      if (state.currentProject.id) {
        return state.currentProject.id;
      }
      if (state.currentTask.project) {
        return state.currentTask.project.id;
      }
      return null;
    }
  },

  mutations: {
    setTasks(state, tasks) {
      state.tasks = tasks;
    },
    setCurrentTask(state, task) {
      state.currentTask = task;
    },

    addTask(state, task) {
      state.tasks.unshift(task);
    },
    setNotes(state, notes) {
      state.notes = notes;
    },
    addNote(state, note) {
      state.notes.push(note);
    },
    editNote(state, data) {
      state.notes.forEach(note => {
        if (data.id === note.id) {
          note.markdown = data.markdown;
          note.html = data.html;
          note.type = data.type;
        }
      });
    },

    setCurrentProject(state, project) {
      state.currentProject = project;
    },

    setPosts(state, posts) {
      state.posts = posts;
    },
  },

  actions: {
    loadTasks(context, payload) {
      let params = {};
      if (!payload.projectId) {
        return;
      }

      axios.get('/api/tasks/project/'+payload.projectId, {
        params: params
      }).then(function(response) {
          context.commit('setTasks', response.data.tasks);
        });
    },
    createTask(context, payload) {
      return axios.post('/api/tasks/create', payload)
        .then(r => r.data);
    },
    setCurrentTaskStatus(context, payload) {
      return axios.post('/api/tasks/set-status/'+context.state.currentTask.id + '/' + payload.status)
        .then(response => {
          context.commit('setCurrentTask', response.data.task);
        });
    },
    setCurrentTaskPriority(context, payload) {
      return axios.post('/api/tasks/set-priority/'+context.state.currentTask.id + '/' + payload.priority)
        .then(response => {
          context.commit('setCurrentTask', response.data.task);
        });
    },

    loadNotes(context, payload) {
      const url = '/notes/get/' + payload.entityType + '/' + payload.entityId;
      return axios.get(url)
        .then(response => {
          context.commit('setNotes', response.data);
        });
    },
    createNote(context, payload) {
      const url = '/notes/add/' + payload.entityType + '/' + payload.entityId;
      const data = {
        markdown: payload.markdown,
        type: payload.type,
      };
      return axios.post(url, data)
        .then(response => {
          context.commit('addNote', response.data);
        });
    },
    editNote(context, payload) {
      const url = '/notes/edit/' + payload.id;
      const data = {
        markdown: payload.markdown,
        type: payload.type,
      };
      return axios.post(url, data)
        .then(response => {
          context.commit('editNote', response.data);
        });
    },

    setCurrentProjectStatus(context, payload) {
      return axios.post('/api/projects/set-status/'+context.state.currentProject.id + '/' + payload.status)
        .then(response => {
          context.commit('setCurrentProject', response.data.project);
        });
    },

    loadPosts(context, payload) {
      let params = {};
      if (!payload.projectId) {
        return;
      }

      axios.get('/api/discussions/project/'+payload.projectId, {
        params: params
      }).then(function(response) {
          context.commit('setPosts', response.data.posts);
        });
    },
  }
});



// WEBPACK FOOTER //
// ./assets/js/store.js